import { useEffect, useRef } from 'react';

export const useOnChange = <T>(value: T, onChange: (oldValue: T, newValue: T) => void) => {
  const valueRef = useRef(value);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (valueRef.current !== value) {
      onChangeRef.current(valueRef.current, value);
      valueRef.current = value;
    }
  }, [value]);
};
